import { render, staticRenderFns } from "./ClientInteractionPage.vue?vue&type=template&id=3545ce12&scoped=true&"
import script from "./ClientInteractionPage.vue?vue&type=script&lang=js&"
export * from "./ClientInteractionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545ce12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
